import { getStoredUser } from 'utils/session';

const initialState = {
  // read once, before the first render, so guarded routes already know who is signed in
  userDetails: getStoredUser(),
  tripsList:[],
  articlesList:[],
  locationByArticle:{},
  locationByBook:{},
  currentLang: { lang: 'en', id: 2 },
  searchTrip:{},
  searchArticle:{},
  articlesList_Trip:[],
  currentTripId:null
};
export default initialState;
